// frontend/src/components/dashboard/AssignSpecialistDialog.js
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Switch,
    Select,
    MenuItem,
    Box,
    Chip,
    OutlinedInput,
    FormControl,
    InputLabel
} from '@mui/material';
import axiosInstance from '../../utils/axios';
import { useTranslation } from 'react-i18next';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const AssignSpecialistDialog = ({ open, onClose, client, onSave }) => {
    const [selectedSpecialists, setSelectedSpecialists] = useState([]);
    const [isVisibleToAll, setIsVisibleToAll] = useState(false);
    const [specialists, setSpecialists] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (open && client) {
            fetchSpecialists();
            // Инициализируем состояние текущими значениями клиента
            setSelectedSpecialists(client.specialistId?.map(s => s._id) || []);
            setIsVisibleToAll(client.isVisibleToAll || false);
        }
    }, [open, client]);

    const fetchSpecialists = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/specialists');
            setSpecialists(response.data.filter(s => s.role !== 'superadmin'));
        } catch (error) {
            console.error('Error fetching specialists:', error);
        }
        setLoading(false);
    };

    const handleSave = () => {
        onSave(client._id, {
            specialistIds: selectedSpecialists,
            isVisibleToAll
        });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('common.assignspecialiststo')} {client?.name}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isVisibleToAll}
                                onChange={(e) => {
                                    setIsVisibleToAll(e.target.checked);
                                    if (e.target.checked) {
                                        setSelectedSpecialists([]);
                                    }
                                }}
                            />
                        }
                        label={t('common.visibletoallspecialists')}
                    />
                </Box>
                {!isVisibleToAll && (
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>{t('common.assignedspecialists')}</InputLabel>
                        <Select
                            multiple
                            value={selectedSpecialists}
                            onChange={(e) => setSelectedSpecialists(e.target.value)}
                            input={<OutlinedInput label={t('common.assignedspecialists')} />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => {
                                        const specialist = specialists.find(s => s._id === value);
                                        return (
                                            <Chip 
                                                key={value} 
                                                label={specialist?.name || value}
                                                onDelete={() => {
                                                    setSelectedSpecialists(
                                                        selectedSpecialists.filter(id => id !== value)
                                                    );
                                                }}
                                            />
                                        );
                                    })}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            {specialists.map((specialist) => (
                                <MenuItem
                                    key={specialist._id}
                                    value={specialist._id}
                                >
                                    {specialist.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.cancel')}</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                {t('common.savechanges')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AssignSpecialistDialog;